// removed by extract-text-webpack-plugin
module.exports = {"crowdfundingTd":"_2PHlFyaJW4Se3YCJUHUskQ","mt":"_3GXLGvIRukRHCVrrcLwRId","bttn":"_2AMFq0gc2IXVGvqpm1WTVX","gray":"_1nv2zwIPzd5KApoZcpOavP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CrowdfundingMessageComponent/CrowdfundingMessageComponent.scss
 ** module id = 957
 ** module chunks = 0
 **/